const roundTo = (n = 0, dp = 2)  => Number.parseFloat(n.toFixed(dp)); 
const f = new Intl.NumberFormat(undefined, {style: 'currency', currency: 'GBP'});

const formatCurrency = (n) => {
    if (Number.isNaN(n) || n === undefined) {
        return f.format(0);
    }
    else {
        return f.format(n);
    }
}

const formatNumber = (n = `0`, dp = 2) => {
    const x = Number.parseFloat(n);

    return !Number.isNaN(x) ? x.toFixed(dp) : undefined;
}

export {
    roundTo,
    formatCurrency,
    formatNumber
}